import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import YearlyReview from "@/pages/YearlyReview";
import LoginGate from "@/components/LoginGate";

function App() {
  return (
    <LoginGate>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/review" element={<YearlyReview />} />
        </Routes>
      </BrowserRouter>
    </LoginGate>
  );
}

export default App;
